import Image from 'next/image';
import style from '../style.module.css';
import { useTranslate } from '~/i18n';
import Breadcrumb from '~/components/common/breadcrumb/business-breadcrumb';
import Container from '~/components/common/container';
import classnames from 'classnames';

interface HeaderProps {
   backgroundColor: string;
   title: string;
   smallBackgroundIamge: string;
   backgroundImage: string;
   backgroundImageAr: string;
   breadCrumbcolor?: string;
   titleColor?: string;
   lastBreadCrumb?: string;
}
const Header = ({
   backgroundColor,
   title,
   smallBackgroundIamge,
   backgroundImage,
   backgroundImageAr,
   breadCrumbcolor,
   titleColor,
   lastBreadCrumb,
}: HeaderProps) => {
   const { dir } = useTranslate();

   return (
      <div>
         <div className="block md:hidden">
            <div className={`flex flex-col py-10 ${style[`${backgroundColor}`]} `}>
               <div className="flex justify-center pt-5 ">
                  <Image src={smallBackgroundIamge} width={552} height={403} />
               </div>
               <Container
                  className={classnames(
                     'text-2xl small:text-3xl sm:text-4xl font-bold',
                     titleColor ? titleColor : 'text-white'
                  )}>
                  {title}
               </Container>
            </div>
         </div>
         <div className="hidden md:block">
            {dir === 'ltr' ? (
               <div
                  className="bg-no-repeat bg-cover bg-center"
                  style={{ backgroundImage: `url(${backgroundImage})` }}>
                  <Container>
                     <Breadcrumb
                        breadCrumbColor={breadCrumbcolor}
                        className="pt-14 pb-4 text-sm tablet:pt-6"
                     />
                     <div
                        className={classnames(
                           'text-4xl py-40 font-bold max-w-xs lg:max-w-md',
                           titleColor ? titleColor : 'text-white'
                        )}>
                        {title}
                     </div>
                  </Container>
               </div>
            ) : (
               <div
                  className="bg-no-repeat bg-cover bg-center"
                  style={{
                     backgroundImage: `url(${backgroundImageAr})`,
                  }}>
                  <Container>
                     <Breadcrumb
                        breadCrumbColor={breadCrumbcolor}
                        className="pt-14 pb-4 text-sm tablet:pt-6"
                        lastBreadCrumbText={lastBreadCrumb}
                     />
                     <div
                        className={classnames(
                           'text-4xl py-40 font-bold max-w-xs lg:max-w-md rtl:leading-snug',
                           titleColor ? titleColor : 'text-white'
                        )}>
                        {title}
                     </div>
                  </Container>
               </div>
            )}
         </div>
      </div>
   );
};

export default Header;
